module.exports = __webpack_public_path__ + "static/img/leaderboardImg.9b7cec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/leaderboardImg.png
// module id = 5IWZ
// module chunks = 0